import mark from '@pdw.io/mark';
import App from './app';

import './style/index.scss';
import('focus-visible');

mark();

export default App;
